import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	emailInput: {
		marginBottom: spacing.md,
	},
	paymentInfoTitle: {
		color: colors.text.main,
		margin: `0 0 ${spacing.md}px`,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
	},
	label: {
		color: colors.text.main,
		display: 'block',
		fontSize: typography.fontSizes.sm,
		margin: `0 0 ${spacing.xs}px`,
		textAlign: 'left',
		fontWeight: typography.fontWeights.bold,
	},
	submitButton: {
		marginTop: spacing.md,
	},
	errorMessage: {
		color: colors.danger.main,
		fontSize: typography.fontSizes.sm,
		marginTop: spacing.sm,
		display: 'block',
		textAlign: 'center',
	},
	formContainer: {
		overflowX: 'hidden',
	},
	processingContainer: {
		display: 'flex',
		flexDirection: 'column' as const,
		alignItems: 'center',
		justifyContent: 'center',
		padding: `${spacing.xl}px`,
		minHeight: 200,
		gap: spacing.md,
	},
	processingMessage: {
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		textAlign: 'center' as const,
	},
	processingSubMessage: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		margin: 0,
		textAlign: 'center' as const,
	},
});
